import * as React from 'react';
import { useSelector } from 'react-redux';

import { BuilderContainer } from './Builder';
import { ActionAfterViewObserver } from '../../../../__mocks__/@cian/action-after-viewed-component';
import { BuildersBlock } from '../../components/BuildersBlock';
import { Layout } from '../../components/Layout';
import { getBuilders, getNewbuildingId } from '../../selectors/newbuilding';
import { trackContactBlockShow } from '../Agents/tracking';

export function BuildersContainer() {
  const builders = useSelector(getBuilders);
  const newbuildingId = useSelector(getNewbuildingId);

  const showHandler = React.useCallback(() => {
    trackContactBlockShow(newbuildingId, 'builders');
  }, [newbuildingId]);

  if (builders.length === 0) {
    return null;
  }

  if (builders.length === 1) {
    return (
      <ActionAfterViewObserver triggerOnce callback={showHandler}>
        <Layout>
          <BuilderContainer builder={builders[0]} />
        </Layout>
      </ActionAfterViewObserver>
    );
  }

  return (
    <ActionAfterViewObserver triggerOnce callback={showHandler}>
      <BuildersBlock>
        {builders.map(builder => (
          <BuilderContainer key={builder.id} builder={builder} />
        ))}
      </BuildersBlock>
    </ActionAfterViewObserver>
  );
}
